module.exports = __webpack_public_path__ + "static/media/logoCompany.a0908164.svg";